// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"5a3ad1bb","145":"9fe499e8","194":"44317c7c","223":"c1812a58","341":"af299acb","435":"ee96a0cc","453":"63f8ebd9","461":"8fc02ce0","534":"5373b14c","773":"979038c5","961":"1b83fe2f"}[chunkId] + ".chunk.js";
};